(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kg-mini-product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kg-mini-product-card')) {
    customElements.define(
      'kg-mini-product-card',
      class KgMiniProductCard extends HTMLElement {
        connectedCallback() {
          this.variantId = this.dataset.variantId;
          this.qtyInput = this.querySelector('[data-kg-mpc-qty]');
          this.addButton = this.querySelector('[data-kg-mpc-add]');
          this.addLabel = this.querySelector('[data-kg-mpc-add-label]');
          this.errorEl = this.querySelector('[data-kg-mpc-error]');
          this.priceEl = this.querySelector('[data-kg-mpc-price]');
          this.compareEl = this.querySelector('[data-kg-mpc-compare]');
          this.pills = Array.from(this.querySelectorAll('[data-kg-mpc-pill]'));

          this.querySelector('[data-kg-mpc-decrease]')?.addEventListener('click', () => this.step(-1));
          this.querySelector('[data-kg-mpc-increase]')?.addEventListener('click', () => this.step(1));
          this.addButton?.addEventListener('click', this.onAdd.bind(this));
          this.pills.forEach((pill) => {
            pill.addEventListener('click', () => this.selectVariant(pill));
          });
        }

        selectVariant(pill) {
          this.variantId = pill.dataset.variantId;
          this.dataset.onSale = pill.dataset.compareAtPrice ? 'true' : 'false';
          this.dataset.availability = pill.dataset.available === 'true' ? 'in-stock' : 'sold-out';

          if (this.priceEl) this.priceEl.textContent = pill.dataset.price;
          if (this.compareEl) this.compareEl.textContent = pill.dataset.compareAtPrice || '';

          this.pills.forEach((p) => {
            const selected = p === pill;
            p.classList.toggle('kg-mpc__pill--selected', selected);
            p.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
        }

        step(delta) {
          if (!this.qtyInput) return;
          const next = Math.max(1, (parseInt(this.qtyInput.value, 10) || 1) + delta);
          this.qtyInput.value = next;
        }

        onAdd() {
          if (!this.addButton || this.addButton.hasAttribute('disabled') || !this.variantId) return;

          const quantity = Math.max(1, parseInt(this.qtyInput?.value, 10) || 1);
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const originalLabel = this.addLabel ? this.addLabel.textContent : '';

          if (this.errorEl) this.errorEl.hidden = true;
          this.addButton.setAttribute('disabled', 'disabled');
          if (this.addLabel) this.addLabel.textContent = 'Adding…';

          // Single-item body ({ id, quantity }), not { items: [...] }: this
          // card only ever adds one variant at a time, and Dawn's own
          // cart-notification.js (renderContents -> this.cartItemKey =
          // parsedState.key) needs the top-level .key that /cart/add.js only
          // returns for a single-item add. The { items: [...] } array form
          // (used in kg-bundle.liquid, where multiple distinct variants are
          // genuinely added in one request) returns { items: [...] } instead,
          // with no top-level .key -- that produced a selector matching
          // nothing (`cart-notification-product-undefined`), which is what
          // threw "Cannot read properties of null" here.
          const body = { id: this.variantId, quantity };
          if (cart) {
            body.sections = cart.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
          }

          fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
          })
            .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
            .then(({ ok, data }) => {
              if (!ok) {
                const message =
                  data && (data.description || data.message)
                    ? data.description || data.message
                    : 'Sorry, something went wrong. Please try again, or order on WhatsApp.';
                throw new Error(message);
              }

              if (cart) {
                cart.renderContents(data);
              } else {
                window.location.href = `${routes.cart_url}`;
              }
            })
            .catch((error) => {
              console.error('kg-mini-product-card add to cart failed:', error);
              if (this.errorEl) {
                this.errorEl.textContent = error.message || 'Sorry, something went wrong. Please try again, or order on WhatsApp.';
                this.errorEl.hidden = false;
              }
            })
            .finally(() => {
              this.addButton.removeAttribute('disabled');
              if (this.addLabel) this.addLabel.textContent = originalLabel;
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kg-product-buybox-extras"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kg-bbx-countdown')) {
    customElements.define(
        'kg-bbx-countdown',
        class KgBbxCountdown extends HTMLElement {
          connectedCallback() {
            const windowHours = Number(this.dataset.windowHours) || 0;
            if (windowHours <= 0) return;

            const storageKey = 'kg-offer-start';
            let startMs = Number(window.localStorage?.getItem(storageKey));

            if (!startMs) {
              startMs = Date.now();
              try {
                window.localStorage?.setItem(storageKey, String(startMs));
              } catch (e) {
                // localStorage unavailable (private browsing, etc.) — fall back
                // to a session-only countdown that starts now.
              }
            }

            this.endMs = startMs + windowHours * 60 * 60 * 1000;
            this.hoursEl = this.querySelector('[data-kg-bbx-hours]');
            this.minutesEl = this.querySelector('[data-kg-bbx-minutes]');
            this.secondsEl = this.querySelector('[data-kg-bbx-seconds]');

            this.tick();
          }

          disconnectedCallback() {
            clearInterval(this.interval);
          }

          tick() {
            const remainingMs = this.endMs - Date.now();

            if (remainingMs <= 0) {
              // Inline style, not the `hidden` attribute: this element shares
              // the .kg-bbx__box class, whose `display: flex` rule has higher
              // specificity than the browser's default `[hidden]` UA style
              // and was winning, so an expired timer stayed on-screen frozen
              // at 00:00:00 instead of disappearing.
              this.style.display = 'none';
              clearInterval(this.interval);
              return;
            }

            const totalSeconds = Math.floor(remainingMs / 1000);
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            this.hoursEl.textContent = String(hours).padStart(2, '0');
            this.minutesEl.textContent = String(minutes).padStart(2, '0');
            this.secondsEl.textContent = String(seconds).padStart(2, '0');

            this.style.display = 'flex';
            if (!this.interval) {
              this.interval = setInterval(this.tick.bind(this), 1000);
            }
          }
        }
      );
    }
  } catch(e) { console.error(e); }
})();

})();
